import React from "react";
import "../styles/Footer.css";

const año = new Date().getFullYear();

// Tel y WhatsApp (sin espacios)
const PHONE_E164 = "+573205002319";
const WHATS_LINK = `https://wa.me/573205002319?text=${encodeURIComponent(
  "Hola Biogrand, me gustaría recibir información. Gracias."
)}`;

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-overlay">
        <div className="footer-container">
          {/* Sobre */}
          <div className="f-col">
            <h4>Sobre Biogrand</h4>
            <p>
              Fertilizantes orgánico–minerales para una agricultura sostenible.
              Acompañamos al productor con asesoría técnica y productos
              confiables para cada etapa del cultivo.
            </p>
          </div>

          {/* Enlaces */}
          <nav className="f-col">
            <h4>Enlaces</h4>
            <ul className="f-links">
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .getElementById("hero")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Inicio
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .getElementById("indices")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Nosotros
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .getElementById("clientes")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Clientes
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .getElementById("productos")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Productos
                </a>
              </li>
            </ul>
          </nav>

          {/* Horario */}
          <div className="f-col">
            <h4>Horario de atención</h4>
            <p>lun – vie: 8:00 AM – 6:00 PM</p>
            <p>sáb: 8:00 AM – 1:00 PM</p>
          </div>

          {/* Contacto */}
          <div className="f-col">
            <h4>Contáctanos</h4>
            <ul className="f-contact">
              <li>
                <span />
                <p>Km 3 Via Pichichi - Ginebra – Valle del Cauca</p>
              </li>
              <li>
                <span />
                <p>Oficina: Cra 101 b # 11a- 49 - Cali</p>
              </li>

              {/* Correo: abre cliente de correo */}
              <li>
                <a href="mailto:comercial@biogrand.com.co">
                  <span  />Comercial@biogrand.com.co</a>
              </li>

              {/* WhatsApp: abre chat directamente */}
              <li>
                <a
                  href={WHATS_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chatear por WhatsApp"
                >
                  <span  />WhatsApp: (+57) 320 500 23 19</a>
              </li>
            </ul>

            {/* Redes sociales */}
            <div className="f-social">
              {/* <a href="https://facebook.com" aria-label="Facebook" className="soc soc-fb" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path fill="currentColor" d="M13 10h3l.5-3H13V5.5c0-.9.3-1.5 1.7-1.5H17V1.1C16.4 1 15.3 1 14 1c-2.6 0-4.3 1.6-4.3 4.4V7H7v3h2.7v10H13V10z"/></svg>
              </a>

              <a href="https://instagram.com" aria-label="Instagram" className="soc soc-ig" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 2.2c3 0 3.4 0 4.6.1 1.2.1 1.9.3 2.3.5.6.2 1 .6 1.5 1.1.5.5.9.9 1.1 1.5.2.4.4 1.1.5 2.3.1 1.2.1 1.6.1 4.6s0 3.4-.1 4.6c-.1 1.2-.3 1.9-.5 2.3-.2.6-.6 1-1.1 1.5-.5.5-.9.9-1.5 1.1-.4.2-1.1.4-2.3.5-1.2.1-1.6.1-4.6.1s-3.4 0-4.6-.1c-1.2-.1-1.9-.3-2.3-.5-.6-.2-1-.6-1.5-1.1-.5-.5-.9-.9-1.1-1.5-.2-.4-.4-1.1-.5-2.3C2.2 15.4 2.2 15 2.2 12s0-3.4.1-4.6c.1-1.2.3-1.9.5-2.3.2-.6.6-1 1.1-1.5.5-.5.9-.9 1.5-1.1.4-.2 1.1-.4 2.3-.5C8.6 2.2 9 2.2 12 2.2z"/></svg>
              </a>

              <a href="https://linkedin.com" aria-label="LinkedIn" className="soc soc-li" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path fill="currentColor" d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5A2.5 2.5 0 0 1 2.5 1c1.38 0 2.48 1.12 2.48 2.5zM0 8.98h4.99V24H0V8.98zM8.98 8.98H14v2.05h.07c.7-1.33 2.42-2.73 4.98-2.73 5.33 0 6.32 3.5 6.32 8.05V24h-4.99v-6.63c0-1.58-.03-3.62-2.2-3.62-2.2 0-2.54 1.72-2.54 3.5V24H8.98V8.98z"/></svg>
              </a>*/}

              <a href="https://wa.me/573205002319" aria-label="WhatsApp" className="soc soc-wa" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="currentColor">
                  <path
                    fill="#ffffffff"
                    d="M16 .5C7.5.5.5 7.5.5 16c0 2.8.7 5.5 2.1 7.9L.5 31.5l7.7-2.1C10.5 30.3 13.2 31 16 31c8.5 0 15.5-7 15.5-15.5S24.5.5 16 .5z"
                  />
                  <path
                      fill="#25d365ff"
                      d="M24 21.2c-.3.9-1.7 1.6-2.4 1.7-.6.1-1.3.2-2.1-.1-.5-.2-1.2-.4-2.1-.8-3.8-1.6-6.2-5.4-6.4-5.7-.2-.3-1.5-2-1.5-3.8
                        0-1.8.9-2.6 1.2-2.9.3-.3.8-.4 1.1-.4h.8c.3 0 .6 0 .8.6.3.8 1.1 2.6 1.2 2.8.1.2.1.4 0 .6-.1.2-.2.4-.4.6-.2.2-.4.4-.6.6-.2.2-.4.4-.2.7
                        .2.3 1 1.6 2.1 2.6 1.5 1.3 2.7 1.7 3.1 1.9.4.2.6.2.9-.1.3-.3 1.2-1.3 1.5-1.7.3-.4.6-.3 1-.2.4.2 2.5 1.2 2.9 1.4.4.2.7.3.8.5.1.2.1 1.1-.2 2z"
                    />
                </svg>
              </a>
              {/* Email */}
              <a href="mailto:comercial@biogrand.com.co" aria-label="Enviar Email" className="soc soc-mail" >
                <svg viewBox="0 0 24 24"><path fill="#ffffffff" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18 c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6 c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
              </a>
              {/*
              <a href="https://youtube.com" aria-label="YouTube" className="soc soc-yt" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24"><path fill="currentColor" d="M23.5 6.2s-.2-1.6-.8-2.3c-.8-.8-1.6-.8-2-0.9C17.6 2.7 12 2.7 12 2.7h-.1s-5.6 0-8.7.3c-.5.1-1.2.1-2 0.9C.7 4.6.5 6.2.5 6.2S0 8.1 0 10v3.9c0 1.9.5 3.8.5 3.8s.2 1.6.8 2.3c.8.8 1.9.8 2.4.9 1.8.2 7.6.3 7.6.3s5.6 0 8.7-.3c.5-.1 1.2-.1 2-0.9.6-.7.8-2.3.8-2.3s.5-1.9.5-3.8V10c.1-1.9-.4-3.8-.4-3.8zM9.8 14.7V9.3l6.3 2.7-6.3 2.7z"/></svg>
              </a>*/}
            </div>
          </div>
        </div>

        <hr className="f-divider" />

        <div className="f-bottom">
          <p>© {año} Biogrand. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
